import { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { fmtNumber } from './format';
import { c, t, sp } from '../../theme';

// A table folded behind a link, so charts lead the page and the numbers stay
// one click away rather than several screens down.
//
// Every chart on this board gets one. That is not decoration: a chart is a
// lossy view — this board's charts rank a top twelve, band a continuum, and
// round to whole dollars — and the table is where the reader recovers what the
// marks dropped. It is also the accessible alternative to the graphic, which is
// why this is a real <button> carrying aria-expanded rather than a styled div:
// reaching it by keyboard is the point, not a nicety.
//
// Collapsed by DEFAULT, but the row count is always in the label. "Show the
// numbers" with no quantity gives no sense of whether it hides four rows or
// ninety, and a disclosure whose size is unknowable is one people stop opening.
export default function DataDisclosure({ label, count, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={s.disclosure}>
      <button
        style={s.disclosureBtn}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <ChevronRight
          size={13}
          style={{ transform: open ? 'rotate(90deg)' : 'none', transition: 'transform 0.15s ease' }}
        />
        {open ? 'Hide' : 'Show'} the numbers
        {count ? <span style={s.disclosureCount}>{fmtNumber(count)} {label} rows</span> : null}
      </button>
      {open && <div style={s.disclosureBody}>{children}</div>}
    </div>
  );
}

const s = {
  disclosure: { borderTop: `1px solid ${c.border}` },
  disclosureBtn: {
    display: 'flex', alignItems: 'center', gap: sp[2], width: '100%',
    padding: `${sp[3]} ${sp[5]}`, background: c.surfaceSunk, border: 'none',
    ...t.bodySm, fontWeight: 600, color: c.navy, cursor: 'pointer',
    fontFamily: 'inherit', textAlign: 'left',
  },
  disclosureCount: { ...t.micro, fontWeight: 400, color: c.textFaint },
  disclosureBody:  { borderTop: `1px solid ${c.border}` },
};
